<template>
  <div
    :class="className"
    class="pr-3 pt-3 pb-0"
  >
    <v-toolbar
      color="white"
      class="app-header gray--text"
      tabs
      flat
    >
      <h1
        :title="title"
        class="title"
      >
        {{ title }}
      </h1>
      <v-spacer />
      <v-btn
        v-if="backButton"
        @click="back"
        flat
        color="secondary"
      >
        Voltar
      </v-btn>
      <v-menu
        v-if="options.length"
        origin="center center"
        transition="scale-transition"
        bottom
        left
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon class="gray--text darken-4">
            more_vert
          </v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(option, index) in options.filter(
              ({ show }) => show === undefined || !!show
            )"
            :key="index"
            :disabled="option.disabled"
            @click="emit(option.method)"
          >
            <v-list-tile-title>{{ option.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-tabs
        slot="extension"
        :value="activeTab"
        show-arrows
      >
        <v-tabs-slider color="secondary" />
        <v-tab
          v-for="(item, index) in onItems"
          :key="index"
          @click.native.prevent.stop.capture="onSelect(item)"
        >
          {{ item.title }}
        </v-tab>
      </v-tabs>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',

  props: {
    title: {
      type: String,
      default: () => ''
    },
    items: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    owner: {
      type: Object,
      default: () => {}
    },
    backButton: {
      type: Object,
      default: () => {}
    },
    className: {
      type: String,
      default: 'mb-3'
    }
  },

  data: () => ({
    activeTab: ''
  }),

  watch: {
    '$route.params.type': {
      handler: function (value) {
        this.redirectToIfUnauthorized()
        this.activeTab = this.onItems.findIndex((item) => item.value === value)
      },
      immediate: true
    }
  },

  computed: {
    onItems() {
      return this.items.filter((item) => item.show(this.owner) && this.hasPermission(item))
    }
  },

  methods: {
    onSelect(item) {
      this.$emit('onSelect', item)
    },
    back() {
      const { container, page, action, params } = this.backButton
      this.$redirect(container, page, action, params)
    },
    emit(method) {
      this.$emit(method)
    },
    hasPermission({ auth }) {
      if (!auth) return true
      return this.$accessControl(auth)
    },
    redirectToIfUnauthorized() {
      const currentItem = this.items.find(item => item?.value === this.$route.params?.type)
      if (!this.hasPermission(currentItem)) {
        const container = this.$route.path.split('/')[1]
        const context = this.$route.path.split('/')[2]
        const firstItem = this.items[0]?.value
        this.$redirect(container, context, firstItem)
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.title
   color: var(--neutral-high-dark)
   font-size: 36px !important
   font-weight: 700
   white-space: nowrap
   text-overflow: ellipsis
   overflow: hidden
 .v-toolbar
   ::v-deep.v-toolbar__content
     padding-left: 16px
   ::v-deep.v-toolbar__extension
     padding-left: 16px
 .v-tabs
   ::v-deep.v-tabs__bar
     background-color: transparent !important
.v-tabs__div
  color: var(--secondary-dark) !important
  ::v-deep.v-tabs__item
    opacity: 1 !important
  .v-tabs__slider.secondary
    background-color: var(--secondary-dark) !important
</style>
